import styled from 'styled-components';

const Modal = styled.div`
    position: absolute;
    border-radius: 1px;
    background-color: ${({ theme }) => theme.colors.white};
    box-shadow: 0 2px 4px 0 rgba(28,28,28,0.2);
    top: 74px;
`;

export const AlignmentButton = styled.div`
    border: none;
    background: ${({ active, theme }) => (active ? theme.colors.primary300 : 'none')};
    color: ${({ active, theme }) => (active ? theme.colors.white : theme.colors.neutral700)};
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    height: 28px;
    margin: 0 4px;
    outline: none;
    padding: 0;
    width: 28px;
`;

export const AlignmentModal = styled(Modal)`
    width: 115px;
    border: ${({ theme }) => `1px solid ${theme.colors.neutral100}`};
    z-index: 2;
`;

export const ModalOption = styled.div`
    display: flex;
    padding: 4px 8px;
    font-size: 13px;
    &:hover {
        background-color: ${({ theme }) => theme.colors.pastelSecondary100};
    }
`;

export const Paragraph = styled.p`
    margin-left: 4px;
`;
export const ToolbarDiv = styled.div`
    left: ${(props) => (props.leftPanelCollapsed ? '64px' : '250px')};
    width: 800px;
    margin: 0 auto;
    display: flex;
`;

export const RightToolbarDiv = styled.div`
    height: 28px;
    margin-top: 43px;
    width: 133px;
    display: flex;
    border-left: ${({ theme }) => `1px solid ${theme.colors.neutral000}`};
    z-index: 5;
    padding-left: 5;
`;

export const LeftButtons = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;
